// Add data-attributes to add and remove positions to/from cart

import api from './container';
import { confirm, handleMessages, load } from './util';
import { KEYCODES } from './util/keycodes';

$(document).on('submit.addCartPosition', '[data-add-cart-position]', function(event) {
  event.preventDefault();
  api.addPosition($(this), 'cart');
});

$(document).on('submit.addCartPositions', '[data-add-cart-positions]', function(event) {
  event.preventDefault();

  const $form = $(this).closest('form');
  const data = $form.serializeArray();

  $('[data-container-position-editmode]:checked').each((idx, input) => {
    data.push({ name: 'position_id', value: input.value });
  });

  load(
    this,
    $.stores.cart.post($form.attr('action'), data),
  );
});

$(document).on('submit.removeCartPositions', '[data-remove-cart-positions]', function(event) {
  event.preventDefault();

  const $form = $(this).closest('form');
  const data = $form.serializeArray();

  $('[data-container-position-editmode]:checked').each((idx, input) => {
    data.push({ name: 'position_id', value: input.value });
  });

  if ($('[data-bind-html="cart:html"]').length) {
    data.push({ name: 'render', value: 1 });
    data.push({ name: 'calculate', value: 1 });
  }

  load(
    this,
    $.stores.cart.post($form.attr('action'), data),
  ).then((result) => {
    if (result.container.position_count === 0) {
      $(this).closest('.position-container').removeClass('position-container--editmode');
      $('[data-container-editmode]').addClass('hide');
    }
  });
});

$(document).on('submit', '[data-add-cart-group-position]', function(event) {
  event.preventDefault();
  api.updateQuantity($(this).find('[data-add-cart-group-position-quantity]').first(), 'cart', true);
});

$(document).on('submit.cartGroupSelect', '[data-cart-group-select]', function(event) {
  event.preventDefault();
  $.ajax({
    method: 'POST',
    url: $(this).attr('action'),
    data: $(this).serialize(),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('submit', '[data-create-and-add-to-cart-group-form]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const $reveal = $form.closest('[data-reveal]');
  const formData = $form.serializeArray();

  if ($form.find('input[name="label"]').length === 0) {
    const label = $form.closest('[data-table-oninput]').find('[data-table-search-query]').text();
    formData.push({ name: 'label', value: label });
  }

  if ($('[data-bind-html="cart:html"]').length) {
    formData.push({ name: 'render', value: 1 });
    formData.push({ name: 'calculate', value: 1 });
  }

  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: formData,
  }).then(handleMessages).then((data) => {
    $.stores.cart.update(data);
    setTimeout(() => $form.closest('[data-reveal]').foundation('close'), 1500);
    return data;
  });

  load($reveal, promise, {
    errorClass: 'error',
  });
});

$(document).on('submit.copyCartPositions', '[data-copy-cart-positions]', function(event) {
  event.preventDefault();
  api.copyPositions($(this), 'cart');
});

$(document).on('submit', '[data-add-cart-position-diversitem]', function(event) {
  event.preventDefault();
  api.addPositionDiversItem($(this), 'cart');
});

$(document).on('submit', '[data-add-cart-position-configuration]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  $('[data-item-configuration-form] input[name=quantity]').val($form.find('input[name=quantity]').val());
  api.addConfigurationItem($form, $('[data-item-configuration-form]'), 'cart');
});

$(document).on('submit', '[data-update-cart-position-configuration]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form').addClass('loading');
  $('[data-item-configuration-form] input[name=quantity]').val($form.find('input[name=quantity]').val());
  $('[data-item-configuration-form]').attr('action', $form.attr('action')).get(0).submit();
});

$(document).on('submit', '[data-update-cart-position]', event => event.preventDefault());

$(document).on('keydown', '[data-update-cart-position-quantity]', function(event) {
  if (event.which === KEYCODES.ENTER) {
    api.updateQuantity($(this), 'cart');
  }
});

$(document).on('keyup', '[data-update-cart-position-quantity]', function() {
  $(this).closest('form')[this.value !== this.defaultValue ? 'addClass' : 'removeClass']('ready');
});

$(document).on('blur', '[data-update-cart-position-quantity]', function() {
  if (!$.isRefocusing) {
    api.updateQuantity($(this), 'cart');
  }
});

$(document).on('submit', '[data-update-cart-position-text]', event => event.preventDefault());
$(document).on('change', '[data-update-cart-position-text]', function(event) {
  event.preventDefault();
  api.setPositionText($(this), 'cart');
});

$(document).on('submit', '[data-remove-cart-position]', function(event) {
  event.preventDefault();
  api.removePosition($(this), 'cart');
});

$(document).on('submit', '[data-clear-cart]', function(event) {
  event.preventDefault();
  api.clear($(this), 'cart');
});

$(document).on('click', '[data-update-cart]', function(event) {
  event.preventDefault();
  api.showUpdateReveal($(this));
});

$(document).on('submit', '[data-cart-update-form]', function(event) {
  event.preventDefault();
  api.updateContainer($(this).closest('form'), 'cart');
});

$(document).on('show.zf.dropdown', '[data-cart-preview]', function() {
  if ($.stores.cart.preview == null) {
    load(
      $(this).find('[data-cart-preview-widget]'),
      $.stores.cart.loadPreview($(this).attr('data-cart-preview')),
    );
  }
});

$(document).on('submit', '[data-remove-cart-preview-position]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const $preview = $form.closest('[data-cart-preview]');
  const data = $form.serializeArray();
  if ($('[data-bind-html="cart:html"]').length) {
    data.push({ name: 'render', value: 1 });
    data.push({ name: 'calculate', value: 1 });
  }

  load(
    $preview.find('[data-cart-preview-widget]'),
    $.stores.cart.post($form.attr('action'), data),
  ).then(() => {
    $preview.foundation('open');
  });
});

$(document).on('submit', '[data-cart-import]', function(event) {
  event.preventDefault();
  api.importPositions($(this), 'cart');
});

$(document).on('closeme.zf.reveal', '[data-cart-import]', function() {
  this.reset();
  $(this).removeClass('error');
  $(this).find('[data-cart-import-messages]').html('').hide()
    .removeClass('alert');
});

$(document).on('click', '[data-change-cart-position-reel]', function(event) {
  event.preventDefault();
  api.changePositionReel($(this), 'cart');
});

$(document).on('submit', '[data-update-cart-position-reel]', function(event) {
  event.preventDefault();
  api.updatePositionReel($(this), 'cart');
});

$(document).on('click', '[data-object-target="cart"][data-object-set]', function (event) {
  event.preventDefault();
  api.setObject($(this), 'cart');
});

$(document).on('click', '[data-object-target="cart"][data-object-reset]', function (event) {
  event.preventDefault();
  api.resetObject($(this), 'cart');
});

$(document).on('change', '[data-activate-cart]', function(event) {
  event.preventDefault();
  $(this).submit();
});

$(document).on('submit', '[data-switch-cart]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const $reveal = $form.closest('[data-reveal]');
  const $cart = $('[data-bind-html="cart:html"][data-container-id]');
  const $editMode = $('[data-container-editmode]');
  if ($cart.length) {
    $cart.attr('data-container-id', $(this).attr('data-switch-cart'));
  }

  load(
    $reveal,
    $.stores.cart.activate($form.attr('action'), $form.serializeArray()),
  ).then((data) => {
    if ($editMode.length && data.container && data.container.get_absolute_url) {
      document.location.href = data.container.get_absolute_url;
      return null;
    }
    setTimeout(() => $reveal.foundation('close'), 1500);
    return data;
  });
});

$(document).on('click', '[data-cart-switch]', function (event) {
  event.preventDefault();
  $.ajax({
    url: $(this).attr('href'),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('submit', '[data-create-cart]', function (event) {
  event.preventDefault();
  const $form = $(this).closest('form');
  const $reveal = $form.closest('[data-reveal]');

  const data = $form.serializeArray();
  if ($form.find('input[name="label"]').length === 0) {
    const label = $form.closest('[data-table-oninput]').find('[data-table-search-query]').text();
    data.push({ name: 'label', value: label });
  }

  load(
    $reveal,
    $.stores.cart.create($form.attr('action'), data),
  ).then((response) => {
    if (response.status) {
      setTimeout(() => $reveal.foundation('close'), 1500);
    } else {
      if (response.errors) {
        const $content = $form.closest('.reveal__content');
        const $input = $content.find('input[name="label"]');
        if ($input.length) {
          $content.find('.form-error').remove();
          response.errors.forEach((error) => {
            $input.parent().after($(`<span class="form-error is-visible">${error}</span>`));
          });
          $input.addClass('is-invalid-input');
        }
      }
      $reveal.removeClass('loaded');
    }
    return response;
  });
});

$(document).on('submit', '[data-add-to-cart]', function (event) {
  event.preventDefault();
  const $form = $(this);
  const data = $form.serializeArray();

  if ($form.attr('data-add-to-cart') === 'editmode') {
    $('[data-container-position-editmode]:checked').each((idx, input) => {
      data.push({ name: 'position_id', value: input.value });
    });
  }

  $.ajax({
    method: 'POST',
    url: $(this).attr('action'),
    data,
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('change', '[data-cart-positions-ordering]', function(event) {
  event.preventDefault();
  $(this).submit();
});

$(document).on('click', '[data-cart-group-update]', function(event) {
  event.preventDefault();
  api.showUpdateReveal($(this));
});

$(document).on('submit', '[data-cart-group-update-form]', function(event) {
  event.preventDefault();
  api.updateGroup($(this), 'cart');
});

$(document).on('submit', '[data-cart-group-delete]', function(event) {
  event.preventDefault();
  const $form = $(this);
  const confirmMsg = $form.attr('data-cart-group-delete');
  $form.attr('data-confirm', confirmMsg);

  if (confirmMsg) {
    confirm($form).then(({ confirmed, reveal }) => {
      $form.removeAttr('data-confirm');
      if (confirmed) {
        load(
          reveal,
          $.stores.cart.post($form.attr('action'), $form.serializeArray()),
        ).then(() => {
          reveal.foundation('close');
        });
      }
    }).catch(() => {
    });
  } else {
    load(
      $form,
      $.stores.cart.post($form.attr('action'), $form.serializeArray()),
    );
  }
});
